import React, { type SetStateAction, type Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoModal } from 'vl-common/src/components/Modals';

const RTTModal = ({ rttDef, setRttDef }: { rttDef: boolean; setRttDef: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation('common');
  return (
    <InfoModal width={768} open={rttDef} onOk={() => setRttDef(false)} title="Referral to Treatment (RTT) Definition">
      <table className="wait-list-table" data-testid="rtt-modal-table">
        <thead>
          <tr>
            <th>{t('Code')}</th>
            <th>{t('Description')}</th>
            <th>{t('Definition')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>10</td>
            <td>{t('First activity')}</td>
            <td>{t('First activity in a REFERRAL TO TREATMENT PERIOD')}</td>
          </tr>
          <tr>
            <td>11</td>
            <td>{t('Active monitoring end')}</td>
            <td>{t('First activity at the start of a new REFERRAL TO TREATMENT PERIOD following acti')}</td>
          </tr>
          <tr>
            <td>12</td>
            <td>{t('Consultant referral')}</td>
            <td>{t('The first activity at the start of a new REFERRAL TO TREATMENT PERIOD following')}</td>
          </tr>
          <tr>
            <td>20</td>
            <td>{t('Subsequent activity')}</td>
            <td>{t('Subsequent activity during a REFERRAL TO TREATMENT PERIOD - further activities a')}</td>
          </tr>
          <tr>
            <td>21</td>
            <td>{t('Transfer to another HPC')}</td>
            <td>{t('Subsequent activity during a REFERRAL TO TREATMENT PERIOD anticipated by another')}</td>
          </tr>
          <tr>
            <td>30</td>
            <td>{t('First treatment')}</td>
            <td>{t("The start of the first treatment that is intended to manage a PATIENT's disease,")}</td>
          </tr>
          <tr>
            <td>31</td>
            <td>{t('Start of active mon. (PATIENT)')}</td>
            <td>{t('Start of active monitoring initiated by the PATIENT')}</td>
          </tr>
          <tr>
            <td>32</td>
            <td>{t('Start of active mon. (CP)')}</td>
            <td>{t('Start of active monitoring initiated by the CARE PROFESSIONAL')}</td>
          </tr>
          <tr>
            <td>33</td>
            <td>{t('Failure to attend')}</td>
            <td>{t('The PATIENT failed to attend the first CARE ACTIVITY after the referral')}</td>
          </tr>
          <tr>
            <td>34</td>
            <td>{t('Decision not to treat')}</td>
            <td>{t('Decision not to treat made or no further contact required')}</td>
          </tr>
          <tr>
            <td>35</td>
            <td>{t('PATIENT declined treatment')}</td>
            <td>{t('PATIENT declined offered treatment')}</td>
          </tr>
          <tr>
            <td>36</td>
            <td>{t('PATIENT died')}</td>
            <td>{t('PATIENT died before treatment')}</td>
          </tr>
          <tr>
            <td>90</td>
            <td>{t('After treatment')}</td>
            <td>{t('First treatment occurred previously (for example, admitted as an emergency from')}</td>
          </tr>
          <tr>
            <td>91</td>
            <td>{t('Active monitoring')}</td>
            <td>{t('CARE ACTIVITY during period of active monitoring')}</td>
          </tr>
          <tr>
            <td>92</td>
            <td>{t('Not yet referred')}</td>
            <td>{t('Not yet referred for treatment, undergoing diagnostic tests by GP before referra')}</td>
          </tr>
          <tr>
            <td>98</td>
            <td>{t('Not applicable')}</td>
            <td>{t('ACTIVITY not applicable to REFERRAL TO TREATMENT PERIODS, for example, not a con')}</td>
          </tr>
          <tr>
            <td>99</td>
            <td>{t('Not yet known')}</td>
            <td>{t('Not yet known')}</td>
          </tr>
        </tbody>
      </table>
    </InfoModal>
  );
};

export default RTTModal;
